import {Injectable, NgZone} from '@angular/core';
import {Observable, of} from 'rxjs';
import {NativeEventSource, EventSourcePolyfill} from 'event-source-polyfill';
import {WindowRefService} from '../window-ref.service';

@Injectable({
    providedIn: 'root'
})
export class NotifComparatorService {
    private zone = new NgZone({enableLongStackTrace: false});
    constructor(private winRef: WindowRefService) {}

    watch(): Observable<object> {
        return Observable.create((observer) => {
            try {
                const url = new URL(this.winRef.appConfigSite.hubUrl);
                url.searchParams.append('topic', "comparator_".concat(this.winRef.appConfigSite.userTokenHub.toString()));
                url.searchParams.append('topic', "viewresa_".concat(this.winRef.appConfigSite.userTokenHub.toString()));
                //url.searchParams.append('topic', "{{topic}}");
                const eventSource = new EventSourcePolyfill(url, {
                    headers: {
                        'Authorization': 'Bearer '.concat(this.winRef.appConfigSite.tokenHub),
                    }
                });

                eventSource.onmessage = event => this.zone.run(() => observer.next(JSON.parse(event.data)));
                eventSource.onerror = error => this.zone.run(() => observer.error(error));
                return () => eventSource.close();
            } catch (e) {
                console.log(e);
                return of(null);
            }
        });
    }
}
